import axios from "axios";

const api = token => {
    return axios.create({
        baseURL: `${process.env.REACT_APP_API_PATH}/api/v1`,
        timeout: 10000,
        headers: { 
            "Cache-Control": "no-cache",
            "x-access-token": token ? token: localStorage.getItem("token")
        }
    });
}

export default api;
